import PropTypes from 'prop-types'
import MaskedFiel from './MaskedField'

class PhoneField extends MaskedFiel {
    constructor(props){
        super(props);
        this.state = {...this.state, mask:[0, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/]};
    }
}

PhoneField.propTypes= {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
}

export default PhoneField


// WEBPACK FOOTER //
// ./src/components/custom/PhoneField.js